export default "__VITE_ASSET__ed51f783__"